const ar = {
  link: {
    enter_link_title_en: "أدخل عنوان الارتباط",
    enter_link: "أدخل الارتباط",
    add_icon: "إضافة رمز",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    link_cap: "اتصال",
    add: "يضيف",
    edit: "يحرر",
    link_is_required: "عنوان الارتباط مطلوب",
    link_url_required: "رابط URL مطلوب",
    select_lang: "اختر لغة",
  },

  avatar: {
    save_cap: "يحفظ",
    delete_cap: "حذف",
    add: "يضيف",
    edit: "يحرر",
    avatar: "الصورة الرمزية",
    drop_your_img: "قم بإسقاط صورتك هنا أو",
    browse_image: "تصفح الصورة",
    maximum: "أقصى",
    choose_another: "اختر آخر",
    size: "بحجم",
    select_lang: "اختر لغة",
    shape: "شكل",
  },

  qr_code: {
    save_cap: "يحفظ",
    delete_cap: "حذف",
    add: "يضيف",
    edit: "يحرر",
    select_lang: "اختر لغة",
    Qr_code: "رموز QR",
  },

  texteditor: {
    save_cap: "يحفظ",
    delete_cap: "حذف",
    add: "يضيف",
    edit: "يحرر",
    select_lang: "اختر لغة",
    text: "نص",
  },
  faq: {
    faq: "التعليمات",
    add_faq: "أضف الأسئلة المتداولة",
    question_required: "السؤال مطلوب",
    select_lang: "اختر لغة",
    answer_required: "الجواب المطلوب",
    enter_answer: "أدخل الجواب",
    enter_question: "أدخل السؤال",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    add: "يضيف",
    edit: "يحرر",
  },
  media: {
    add: "يضيف",
    edit: "يحرر",
    enter_link: "أدخل الارتباط",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    select_lang: "اختر لغة",
  },
  image: {
    image: "صورة",
    drop_your_img: "قم بإسقاط صورتك هنا أو",
    browse_image: "تصفح الصورة",
    maximum: "أقصى",
    description: "وصف",
    enter_alt_text: "أدخل النص البديل",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    select_lang: "اختر لغة",
    add: "يضيف",
    edit: "يحرر",
    choose_another: "اختر آخر",
  },
  imagegrid: {
    add_image_grid: "أضف شبكة صور",
    maximum: "أقصى",
    drop_your_img: "قم بإسقاط صورتك هنا أو",
    browse_image: "تصفح الصورة",
    select_lang: "اختر لغة",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    add: "يضيف",
    edit: "يحرر",
    image_grid: "شبكة الصورة",
  },
  divider: {
    divider: "مقسم",
    add_divider: "إضافة مقسم",
    divider_cap: "مقسم",
    color: "اللون",
    select_lang: "اختر لغة",
    add: "يضيف",
    edit: "يحرر",
    save_cap: "يحفظ",
    delete_cap: "حذف",
  },
  addcountdown: {
    countdown: "العد التنازلي",
    select_lang: "اختر لغة",
    add_countdown: "أضف مؤقتًا للعد التنازلي",
    enter_countdown_description: "أدخل وصف العد التنازلي",
    choose_date: "اختر تاريخًا",
    choose_time: "اختر الوقت",
    timer_digit_color: "لون أرقام الموقت",
    timer_background_color: "لون خلفية الموقت",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    edit_countdown: "تحرير العد التنازلي",
  },
  header: {
    header: "رأس",
    add_header: "إضافة رأس",
    enter_page_name: "أدخل اسم الصفحة",
    enter_page_title: "أدخل عنوان الصفحة",
    pagename_required: "اسم الصفحة مطلوب",
    pagetitle_required: "عنوان الصفحة مطلوب",
    contact_required: "الاتصال مطلوب",
    edit_header: "تحرير الرأس",
    whatapp_required: "مطلوب واتس اب",
    whatapp: "واتس اب",
    profile_alignment: "محاذاة الملف الشخصي",
    left: "غادر",
    center: "مركز",
    right: "يمين",
    want_to_set_background_image: "تريد تعيين صورة الخلفية",
    avatar_size: "حجم الصورة الرمزية",
    avatar_shape: "الشكل الرمزي",
    avatar_outline: "الخطوط العريضة للصورة الرمزية",
    image_smaller_than_3MB: "يجب أن يكون حجم الصورة أقل من 3 ميجابايت",
    select_lang: "اختر لغة",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    choose_avatar: "اختر الصورة الرمزية",
    contact: "اتصل",
    drop_your_img: "قم بإسقاط صورتك هنا أو",
    browse_image: "تصفح الصورة",
    maximum: "أقصى",
    choose_another: "اختر آخر",
    yes: "نعم",
    no: "رقم",
    circle: "دائرة",
    corners: "الزوايا",
    rounded: "مدور",
    straight: "مستقيم",
    color: "اللون",
  },
  socials:{
    socials: "الاجتماعية",
    select_lang: "اختر لغة",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    add: "يضيف",
    edit: "يحرر",
    enter: "يدخل",
  },
  location: {
    addpin: "إضافة دبوس",
    cancel_adding_pin: "إلغاء إضافة دبوس",
    adress: "العنوان",
    adress_placeholder: "123 الشارع الرئيسي، المدينة",
    phone: "هاتف",
    phone_placeholder: "١٢٣-٤٥٦-٧٨٩٠",
    add_location: "أضف الموقع",
    set_primary: "تعيين كأساسي",
    primary_location: "الموقع الرئيسي",
    get_directions: "احصل على الاتجاهات",
    added_any_location: "لم تقم بإضافة أي موقع",
    adress_title_caps: "إضافة عنوان العنوان",
    adress_details_caps: "إضافة تفاصيل العنوان",
    enter_location_name: "أدخل اسم الموقع",
    enter_location_adress: "أدخل عنوان الموقع",
    enter_location_phone: "أدخل هاتف الموقع",
    set_default_location:
      "قم بتعيين هذا الموقع باعتباره الموقع الرئيسي/الافتراضي",
    home: "بيت",
    select_lang: "اختر لغة",
    save_cap: "يحفظ",
    delete_cap: "حذف",
    add_location: "إضافة الموقع",
    edit_location: "تحديد الوجهة",
  },
  want_to_delete: "هل أنت متأكد أنك تريد حذف هذا؟",
  cancel: "يلغي",
  delete_cap: "حذف",
};

export default ar;
